/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL_IDENTIFYING = new InjectionToken<string>('API_BASE_URL_IDENTIFYING');

@Injectable()
export class IdentifyingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_IDENTIFYING) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get cluster groups
     * @return Returns a list of cluster groups
     */
    getClusterGroups(): Observable<ClusterGroupDto[]> {
        let url_ = this.baseUrl + "/clustergroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClusterGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClusterGroups(<any>response_);
                } catch (e) {
                    return <Observable<ClusterGroupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClusterGroupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClusterGroups(response: HttpResponseBase): Observable<ClusterGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClusterGroupDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClusterGroupDto[]>(<any>null);
    }

    /**
     * Get clusters
     * @param clusterGroupIds (optional) A comma-separated list of unique identifiers of cluster groups
     * @return Returns a list of clusters
     */
    getClusters(clusterGroupIds?: string | undefined): Observable<ClusterTranslatedDto[]> {
        let url_ = this.baseUrl + "/clusters?";
        if (clusterGroupIds === null)
            throw new Error("The parameter 'clusterGroupIds' cannot be null.");
        else if (clusterGroupIds !== undefined)
            url_ += "clusterGroupIds=" + encodeURIComponent("" + clusterGroupIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClusters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClusters(<any>response_);
                } catch (e) {
                    return <Observable<ClusterTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClusterTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClusters(response: HttpResponseBase): Observable<ClusterTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClusterTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClusterTranslatedDto[]>(<any>null);
    }

    /**
     * Get countries
     * @return Returns a list of countries
     */
    getCountries(): Observable<CountryTranslatedDto[]> {
        let url_ = this.baseUrl + "/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<CountryTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<CountryTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryTranslatedDto[]>(<any>null);
    }

    /**
     * Get domains
     * @return Returns a list of domains
     */
    getDomains(): Observable<DomainTranslatedDto[]> {
        let url_ = this.baseUrl + "/domains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomains(<any>response_);
                } catch (e) {
                    return <Observable<DomainTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DomainTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomains(response: HttpResponseBase): Observable<DomainTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DomainTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DomainTranslatedDto[]>(<any>null);
    }

    /**
     * Create a job scan
     * @param body (optional) The job scan to be created
     * @return Success
     */
    createJobScan(body?: CreateJobScanDto | undefined): Observable<JobScanDto> {
        let url_ = this.baseUrl + "/jobscans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobScan(<any>response_);
                } catch (e) {
                    return <Observable<JobScanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<JobScanDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateJobScan(response: HttpResponseBase): Observable<JobScanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobScanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanDto>(<any>null);
    }

    /**
     * Get job scans for account of current connected client
     * @param externalRef (optional) The unique reference of the job scan at the account side
     * @param shouldHaveExpectations (optional) Whether job scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning job scans should include expectations or not
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of job scans for the current identified account
     */
    getJobScans(externalRef?: string | undefined, shouldHaveExpectations?: boolean | undefined, includeExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, offset?: number | undefined, count?: number | undefined, sort?: string | undefined, search?: string | undefined, domainIds?: string | undefined): Observable<JobScanDto[]> {
        let url_ = this.baseUrl + "/jobscans?";
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScans(<any>response_);
                } catch (e) {
                    return <Observable<JobScanDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<JobScanDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScans(response: HttpResponseBase): Observable<JobScanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobScanDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanDto[]>(<any>null);
    }

    /**
     * Delete job scans
     * @param ids (optional) Comma-separated list of ids of the job scans to delete
     * @return Returns status code 204 if successfully deleted
     */
    deleteJobScans(ids?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/jobscans?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobScans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobScans(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteJobScans(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Update a job scan
     * @param body (optional) The job scan to be updated
     * @return Success
     */
    updateJobScan(body?: UpdateJobScanDto | undefined): Observable<JobScanDto> {
        let url_ = this.baseUrl + "/jobscans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobScan(<any>response_);
                } catch (e) {
                    return <Observable<JobScanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<JobScanDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateJobScan(response: HttpResponseBase): Observable<JobScanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobScanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanDto>(<any>null);
    }

    /**
     * Get job scan by id
     * @return Returns the job scan object
     */
    getJobScan(id: string): Observable<JobScanDto> {
        let url_ = this.baseUrl + "/jobscans/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobScan(<any>response_);
                } catch (e) {
                    return <Observable<JobScanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<JobScanDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobScan(response: HttpResponseBase): Observable<JobScanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobScanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobScanDto>(<any>null);
    }

    /**
     * Get schools
     * @return Returns a list of schools
     */
    getSchools(): Observable<SchoolTranslatedDto[]> {
        let url_ = this.baseUrl + "/schools";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchools(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchools(<any>response_);
                } catch (e) {
                    return <Observable<SchoolTranslatedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SchoolTranslatedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSchools(response: HttpResponseBase): Observable<SchoolTranslatedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchoolTranslatedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SchoolTranslatedDto[]>(<any>null);
    }

    /**
     * Create a talent scan
     * @param language (optional) The two-letter iso code for the talent scan's language, eg 'en'
     * @param body (optional) The talent scan to be created
     * @return Success
     */
    createTalentScan(language?: string | undefined, body?: CreateTalentScanDto | undefined): Observable<TalentScanDto> {
        let url_ = this.baseUrl + "/talentscans?";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTalentScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTalentScan(<any>response_);
                } catch (e) {
                    return <Observable<TalentScanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TalentScanDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTalentScan(response: HttpResponseBase): Observable<TalentScanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TalentScanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanDto>(<any>null);
    }

    /**
     * Delete talent scans
     * @param ids (optional) Comma-separated list of id's of the talent scans to delete
     * @return Returns status code 204 if successfully deleted
     */
    deleteTalentScans(ids?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/talentscans?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTalentScans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTalentScans(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTalentScans(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get talent scans for account of current connected client
     * @param externalRef (optional) The unique reference of the talent scan at the account side
     * @param shouldHaveExpectations (optional) Whether talent scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning talent scans should include expectations or not
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of talent scans for the current identified account
     */
    getTalentScans(externalRef?: string | undefined, shouldHaveExpectations?: boolean | undefined, includeExpectations?: boolean | undefined, teamRoleIds?: string | undefined, workValueIds?: string | undefined, offset?: number | undefined, count?: number | undefined, sort?: string | undefined, search?: string | undefined, domainIds?: string | undefined): Observable<TalentScanDto[]> {
        let url_ = this.baseUrl + "/talentscans?";
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScans(<any>response_);
                } catch (e) {
                    return <Observable<TalentScanDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TalentScanDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScans(response: HttpResponseBase): Observable<TalentScanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TalentScanDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanDto[]>(<any>null);
    }

    /**
     * Update a talent scan
     * @param body (optional) The talent scan to be updated
     * @return Success
     */
    updateTalentScan(body?: UpdateTalentScanDto | undefined): Observable<TalentScanDto> {
        let url_ = this.baseUrl + "/talentscans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTalentScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTalentScan(<any>response_);
                } catch (e) {
                    return <Observable<TalentScanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TalentScanDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTalentScan(response: HttpResponseBase): Observable<TalentScanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TalentScanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanDto>(<any>null);
    }

    /**
     * Get talent scan
     * @return Returns the talent scan object in the system
     */
    getTalentScan(id: string): Observable<TalentScanDto> {
        let url_ = this.baseUrl + "/talentscans/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTalentScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTalentScan(<any>response_);
                } catch (e) {
                    return <Observable<TalentScanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TalentScanDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTalentScan(response: HttpResponseBase): Observable<TalentScanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TalentScanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TalentScanDto>(<any>null);
    }
}

export class ApiError implements IApiError {
    code?: string;
    description?: string | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IApiError {
    code?: string;
    description?: string | undefined;
}

export class ValidationError implements IValidationError {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
    validationErrors?: ValidationError[] | undefined;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IValidationError {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
}

export class ApiErrorResponse implements IApiErrorResponse {
    apiError?: ApiError | undefined;
    correlationId?: string;
    errorMessage?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
    detail?: string | undefined;

    constructor(data?: IApiErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiError = _data["apiError"] ? ApiError.fromJS(_data["apiError"]) : <any>undefined;
            this.correlationId = _data["correlationId"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationError.fromJS(item));
            }
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): ApiErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiError"] = this.apiError ? this.apiError.toJSON() : <any>undefined;
        data["correlationId"] = this.correlationId;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        data["detail"] = this.detail;
        return data; 
    }
}

export interface IApiErrorResponse {
    apiError?: ApiError | undefined;
    correlationId?: string;
    errorMessage?: string | undefined;
    validationErrors?: ValidationError[] | undefined;
    detail?: string | undefined;
}

export class ClusterGroupDto implements IClusterGroupDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: IClusterGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClusterGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IClusterGroupDto {
    id?: string;
    name?: string | undefined;
}

export class Translation implements ITranslation {
    en?: string | undefined;
    nl?: string | undefined;
    fr?: string | undefined;

    constructor(data?: ITranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en = _data["en"];
            this.nl = _data["nl"];
            this.fr = _data["fr"];
        }
    }

    static fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        let result = new Translation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["nl"] = this.nl;
        data["fr"] = this.fr;
        return data; 
    }
}

export interface ITranslation {
    en?: string | undefined;
    nl?: string | undefined;
    fr?: string | undefined;
}

export class ClusterTranslatedDto implements IClusterTranslatedDto {
    id?: string;
    name?: Translation | undefined;

    constructor(data?: IClusterTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClusterTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClusterTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IClusterTranslatedDto {
    id?: string;
    name?: Translation | undefined;
}

export class CountryTranslatedDto implements ICountryTranslatedDto {
    alpha3IsoCode?: string | undefined;
    name?: Translation | undefined;

    constructor(data?: ICountryTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alpha3IsoCode = _data["alpha3IsoCode"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CountryTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alpha3IsoCode"] = this.alpha3IsoCode;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICountryTranslatedDto {
    alpha3IsoCode?: string | undefined;
    name?: Translation | undefined;
}

export class DomainTranslatedDto implements IDomainTranslatedDto {
    id?: string;
    name?: Translation | undefined;

    constructor(data?: IDomainTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DomainTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomainTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDomainTranslatedDto {
    id?: string;
    name?: Translation | undefined;
}

export class CreateJobScanDto implements ICreateJobScanDto {
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;

    constructor(data?: ICreateJobScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [] as any;
                for (let item of _data["contactCcEmail"])
                    this.contactCcEmail!.push(item);
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateJobScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (let item of this.contactCcEmail)
                data["contactCcEmail"].push(item);
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateJobScanDto {
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;
}

export class ExpectationDto implements IExpectationDto {
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;

    constructor(data?: IExpectationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    }

    static fromJS(data: any): ExpectationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpectationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data; 
    }
}

export interface IExpectationDto {
    expectationId?: string;
    score?: number;
    outDated?: boolean;
    rank?: number | undefined;
    reportRank?: number | undefined;
}

export class JobScanDto implements IJobScanDto {
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;
    id?: string;
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;

    constructor(data?: IJobScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [] as any;
                for (let item of _data["expectations"])
                    this.expectations!.push(ExpectationDto.fromJS(item));
            }
            this.id = _data["id"];
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [] as any;
                for (let item of _data["contactCcEmail"])
                    this.contactCcEmail!.push(item);
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
        }
    }

    static fromJS(data: any): JobScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (let item of this.expectations)
                data["expectations"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (let item of this.contactCcEmail)
                data["contactCcEmail"].push(item);
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        return data; 
    }
}

export interface IJobScanDto {
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;
    id?: string;
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;
}

export class UpdateJobScanDto implements IUpdateJobScanDto {
    id?: string;
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;

    constructor(data?: IUpdateJobScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [] as any;
                for (let item of _data["contactCcEmail"])
                    this.contactCcEmail!.push(item);
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateJobScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (let item of this.contactCcEmail)
                data["contactCcEmail"].push(item);
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateJobScanDto {
    id?: string;
    title?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactCcEmail?: string[] | undefined;
    contactPhone?: string | undefined;
    employer?: string | undefined;
    externalRef?: string | undefined;
    domainIds?: string[] | undefined;
    schoolIds?: string[] | undefined;
    clusterIds?: string[] | undefined;
}

export class SchoolTranslatedDto implements ISchoolTranslatedDto {
    id?: string;
    name?: Translation | undefined;

    constructor(data?: ISchoolTranslatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SchoolTranslatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolTranslatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISchoolTranslatedDto {
    id?: string;
    name?: Translation | undefined;
}

export class CreateTalentScanDto implements ICreateTalentScanDto {
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;

    constructor(data?: ICreateTalentScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTalentScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTalentScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateTalentScanDto {
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;
}

export class TalentScanDto implements ITalentScanDto {
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;
    id?: string;
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;

    constructor(data?: ITalentScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [] as any;
                for (let item of _data["expectations"])
                    this.expectations!.push(ExpectationDto.fromJS(item));
            }
            this.id = _data["id"];
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TalentScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new TalentScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (let item of this.expectations)
                data["expectations"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        return data; 
    }
}

export interface ITalentScanDto {
    clientId?: string;
    createdOn?: Date;
    expectations?: ExpectationDto[] | undefined;
    id?: string;
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;
}

export class UpdateTalentScanDto implements IUpdateTalentScanDto {
    id?: string;
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;

    constructor(data?: IUpdateTalentScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [] as any;
                for (let item of _data["clusterIds"])
                    this.clusterIds!.push(item);
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [] as any;
                for (let item of _data["domainIds"])
                    this.domainIds!.push(item);
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [] as any;
                for (let item of _data["schoolIds"])
                    this.schoolIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTalentScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTalentScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (let item of this.clusterIds)
                data["clusterIds"].push(item);
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (let item of this.domainIds)
                data["domainIds"].push(item);
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (let item of this.schoolIds)
                data["schoolIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateTalentScanDto {
    id?: string;
    atsClientId?: string | undefined;
    clusterIds?: string[] | undefined;
    domainIds?: string[] | undefined;
    email?: string | undefined;
    externalRef?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationality?: string | undefined;
    phone?: string | undefined;
    schoolIds?: string[] | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}